export enum CampaignStatus {
  All = "all",
  Pending = "pending",
  Active = "active",
  Deleted = "deleted",
  Inactive = "inactive",
  Completed = "completed",
}

export enum Events {
  Installs = "installs",
  Click = "click",
  CR = "cr",
  Spent = "spent",
}

export enum CampaignFormSteps {
  CampaignSettings = "Campaign Settings",
  Tracking = "Tracking",
  AdCreatives = "Ad-creatives",
  Summary = "Summary",
}

export enum Products {
  App = "app",
  Website = "web",
}

export enum BidTypes {
  "CPC" = "CPC",
  "CPI" = "CPI",
  "CPL" = "CPL",
}

export enum MinBid {
  "CPC" = 0.01,
  "CPI" = 0.2,
  "CPL" = 0.5,
}

export enum CampaignType {
  DirectApps = "direct-apps",
  Open = "open",
  OEM = "oem",
}
